import React from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
const ContactPage: React.FC = () => {
  return <Footer />;
};

export default ContactPage;
